<template>
  <v-app>
    <v-overlay v-if="loading">
      <div class="loading">
        <v-progress-circular indeterminate size="128"></v-progress-circular>
        <div class="ma-3 loading-text">App is loading...</div>
      </div>
    </v-overlay>
    <router-view v-else></router-view>
  </v-app>
</template>

<script>
export default {
  created: async function () {
    while (this.loading) {
      try {
        var host = window.location.hostname;
        var hostParts = host.includes(".") ? host.split(".") : host.split("-");
        var manufacturerId = hostParts[0];
        this.$store.commit("setManufacturerId", manufacturerId);
        await this.$store.dispatch("getLoginConfig");
        this.loading = false;
        this.$router.push(`/Manufacturers/${manufacturerId}/Avenue/Path`);
      } catch (error) {
        alert(error);
      }
    }
  },
  components: {},
  data: function () {
    return {
      loading: true,
    };
  },
  computed: {},
};
</script>

<style lang="scss">
body {
}
.v-application .v-content {
  background-color: rgb(230, 230, 230) !important;
}
div {
  //border: 1px solid black;
}
:focus {
  outline: none;
}
</style>

<style lang="scss">
.tile {
  width: 100%;
  height: 100%;
  border: 1px solid black;
  border-radius: 0px;
  display: flex;
  flex-direction: column;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
  text-decoration: none;
  color: black;
  overflow: hidden;
  position: relative;
  background-color: white;
  cursor: pointer;

  &:hover {
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
    text-decoration: none;
    color: black;
  }

  .snipe {
    position: absolute;
    background-color: black;
    color: white;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    transform: translate(50%, -50%) rotate(45deg);
    top: 40px;
    right: 40px;
    width: 100%;
    text-transform: uppercase;

    &.snipe-platinum {
      background-color: #e5e4e2;
      color: black;
    }

    &.snipe-gold {
      background-color: gold;
      color: white;
    }

    &.snipe-silver {
      background-color: silver;
      color: white;
    }
  }

  .tile-image-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5px;
    overflow: hidden;

    .tile-image {
      max-height: 100%;
      max-width: 100%;
      width: auto;
      height: auto;
    }
  }
  .tile-text-container {
    flex: none;
    height: 60px;
    padding: 5px;
    overflow: hidden;

    .tile-text {
      width: 100%;
      height: 100%;
      text-align: center;
      overflow: hidden;
      //text-transform: uppercase;
    }
  }
  .barcode-container {
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    background-color: white;

    .barcode-img {
      max-width: 100%;
      width: auto;
      height: auto;
    }
  }
}

/* https://www.w3schools.com/howto/howto_css_aspect_ratio.asp */
.aspect-container {
  width: 100%;
  position: relative;
}

.aspect-container-1-1 {
  padding-top: 100%;
}

.aspect-container-16-9 {
  padding-top: 56.25%;
}

.aspect-container-4-3 {
  padding-top: 75%;
}

.aspect-content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>